import Cookies from "universal-cookie";
import { SettingsCookieModal } from "../components/NavigationBar/Models/SettingCookieModel";
import { LoginCookies } from "../views/pages/Login/Models";
import { utils } from "../utils";

const cookies = new Cookies();

class CookieService {
    SettingsCookieName: string = "settingCookies";
    LoginCookieName: string = "loginCookies";


    getLoginCookies = (): LoginCookies | null => {
        if (!utils.isElectronBuild()) {
            return cookies.get(this.LoginCookieName) as LoginCookies | null;
        } else {
            return localStorage.getItem(this.LoginCookieName) as LoginCookies | null;
        }
    }
    setLoginCookies = (cookie: LoginCookies) => {
        if (!utils.isElectronBuild()) {
            return cookies.set(this.LoginCookieName, cookie, { path: "/" });
        } else {
            return localStorage.setItem(this.LoginCookieName, JSON.stringify(cookie));
        }
    };
    getElectronCookies = (value) => {
        if (value == "RoutedSurveyCount") {
            return localStorage.getItem(value);
        }

        if (!utils.isElectronBuild()) {
            return cookies.get(value);
        } else {
            return localStorage.getItem(value);
        }
    }
    setElectronCookies = (key, value) => {
        if (key == "RoutedSurveyCount") {
            return localStorage.setItem(key, value);
        }

        if (!utils.isElectronBuild()) {
            return cookies.set(key, value);
        } else {
            return localStorage.setItem(key, value);
        }
    }

    removeLoginCookies() {
        if (!utils.isElectronBuild()) {
            cookies.remove(this.LoginCookieName);
        } else {
            return localStorage.removeItem(this.LoginCookieName);
        }

    }
    removeElectronCookies(value) {
        if (value == "RoutedSurveyCount") {
            return localStorage.removeItem(value);
        }

        if (!utils.isElectronBuild()) {
            cookies.remove(value);
        } else {
            return localStorage.removeItem(value);
        }

    }

    getSettingsCookies = (): SettingsCookieModal | null => {
        if (!utils.isElectronBuild()) {
            return cookies.get(this.SettingsCookieName) as SettingsCookieModal ?? null;
        } else {
            return (JSON.parse(localStorage.getItem(this.SettingsCookieName)!) as SettingsCookieModal) ?? null;
            // return window.myAPI?.getPersistedSettings();
        }
    };

    setSettingsCookies = (cookie: SettingsCookieModal) => {
        if (!utils.isElectronBuild()) {
            return cookies.set(this.SettingsCookieName, JSON.stringify(cookie));
        } else {
            window.myAPI?.PersistSettings(JSON.stringify(cookie));
            return localStorage.setItem(this.SettingsCookieName, JSON.stringify(cookie));
        }
    };

    getCookies = (key) => {
        return cookies.get(key)
    }
}

var cookieService = new CookieService();

export { cookieService };
